export class Descarga {
  id: number;
  descricao: string;
  percentual: number;
}
